import { atom } from 'recoil'
import { UserEntity } from '../types/entities/user'

export const currentUserState = atom<UserEntity | null>({
  key: 'currentUserState',
  default: null,
})
